<template>
  <div class="question">
    <h4 class="heading">{{ question.heading }}</h4>
    <p class="text">{{ question.text }}</p>
  </div>
</template>

<script>
export default {
  name: "Question",
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.question {
  background: $color-light;
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
  break-inside: avoid;
  padding: 10px;
  margin: 0 0 20px 0;

  @include respond-above(md) {
    padding: 20px;
  }

  .heading {
    color: $color-dark;
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.49px;
    margin: 0 0 10px 0;
    text-transform: uppercase;

    @include respond-above(md) {
      font-size: 10px;
      letter-spacing: 0.55px;
    }
  }

  .text {
    font-size: 10px;
    letter-spacing: 0.55px;
  }
}
</style>
